export default __webpack_public_path__ + "2c93f80d2aeac70d8dcd451121e033a4.svg";